module.exports = __webpack_public_path__ + "img/card-back.a681fc28.png";